import { render, staticRenderFns } from "./TesteReport.vue?vue&type=template&id=0cddd645&scoped=true"
import script from "./TesteReport.vue?vue&type=script&lang=js"
export * from "./TesteReport.vue?vue&type=script&lang=js"
import style0 from "./TesteReport.vue?vue&type=style&index=0&id=0cddd645&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cddd645",
  null
  
)

export default component.exports